module.exports = __webpack_public_path__ + "img/MissionVisionCore_Mobile.b6ffbf68.png";